import {Zero, Components, Logger, Utils} from 'Zero';
import GoogleSearch from 'Vendor/@openmind/storelocator/dist/googlesearch.umd.js';


const Log = new Logger("WE_ZSearch");

export default class ZSearch extends Components {


  get Messages() {
    return {
      "StoreLocator:Init": this.onStoreLocatorInit,
      "Cart:Change:DeliveryMethod": this.onCartDeliveryMethodChanged
    };
  }


  get Selectors() {
    return {
      GeolocationButton: "button.geo-location",
      SearchButton: "button.search",
      SearchInput: "input[name=search]",
      cartClickAndCollectOpt: '.js-click_and_collect-opt'
    };
  }


  get InitialSearch() {
    return Zero.$state.StoreLocator.InitialSearch;
  }

  constructor(element) {
    super(element);

    this.GeoLocationBtn = $('#sl_my-geo');
    this.SearchBtn = $('.sl__search__btn');
    this.InputSearch = $('#sl__search__input');
    this.cartClickAndCollectOpt = $('.js-click_and_collect-opt');


    // this.element.on("submit", function(e) {
    //   e.preventDefault();
    // });
    //disable submit form with enter key --> the myposition button does not get pressed anymore creating wrong execution
    this.InputSearch.on('keypress', (e) => {
      if (e.key === "Enter") {
        e.preventDefault();
      }
    });

    this.InputSearch.on('click.iSearch', (e) => {
      e.currentTarget.value = "";
    });

    this.SearchBtn.on("click.searchBtn", (e) => {
      e.preventDefault();
      this.onSearch();
    });

    this.GeoLocationBtn.on("click.search", (e) => {
      e.preventDefault();
      this.getUserLocation(true);
    });
  }

  onSearch() {
    let value = this.InputSearch.val();
    let p = null;

    if (value.length > 0) {
      p = this.StoreLocator.navigate(value);
    } else {
      p = this.StoreLocator.navigate(this.InitialSearch);
    }

    p.then((obj) => {
      this.onPlaceChanged(obj.results ? obj.results[0] : {name: value});
    });
  }

  autoGeolocation() {
    const inEditorial = document.body.classList.contains('t-editorial');
    const inHomepage = document.body.classList.contains('t-homepage');
    if (inEditorial || inHomepage) {
      return;
    }

    const inCart = document.body.classList.contains('t-cart');

    if (navigator.geolocation && !inCart) {
      this.getUserLocation();
    } else {
      this.cartClickAndCollectOpt.on('click.clickcollect', (e) => {
        this.getUserLocation();
      });

      Log.e('geolocation should be disable or browser cannot be able to retrive position');
    }
  }


  onCartDeliveryMethodChanged(msg) {
    if (msg.method.startsWith("Click-and-Collect")) {
      this.getUserLocation(true);
    }
  }


  getUserLocation(clicked) {
    // MM30-894 force search by boundaries on get user location clicked = true
    clicked = true;

    this.StoreLocator.currentLocation({timeout: 30000}).then((location) => {
      Log.i("Browser geolocation:", location);

      let self = this;

      let geocoder = new google.maps.Geocoder;

      let coordinates = {
        lat: location.lat,
        lng: location.lng
      };

      let latLng = coordinates.lat + ',' + coordinates.lng;

      geocoder.geocode({'location': coordinates}, function (results) {
        let formattedAddress = '';

        for (let result of results) {
          if (result.types[0] === 'postal_code') {
            self.InputSearch.val(result.formatted_address);
            return;
          }
        }
      });

      this.StoreLocator.navigate(null, location).then((obj) => {
        this.onPlaceChanged(obj.results[0], clicked);
      });

    }, function () {
      Log.e("No current location enabled");
    });


  }


  onStoreLocatorInit(msg) {
    this.StoreLocator = msg.StoreLocator;

    Log.info("Got storelocator for ", this.element);

    var options = {
      types: ['(regions)']
    };

    let promise = new GoogleSearch(this.StoreLocator, this.InputSearch, options);

    promise.then((gsearch) => {
      this.StoreLocator.addSearchEngine('GoogleSearch', this.GSearch = gsearch, options);
      this.bindStoreLocator();
      this.autoGeolocation();
      this.bindEngineSearch();
      this.StoreLocator.navigate(this.InitialSearch).then((obj) => {
        this.onPlaceChanged(obj.results[0]);
      });

    }, function () {
      Log.error("Cannot bind GSearch engine");
      throw "Cannot bind GSearch engine";
    });
  }


  bindStoreLocator() {
    // pick up in store autocomplete query restriction
    const inCart = document.body.classList.contains('t-cart');

    if (inCart) {
      const lang = document.body.dataset.language;
      this.GSearch.autocomplete.setComponentRestrictions({
        'country': [lang]
      });
    }
  }

  bindEngineSearch() {
    this.GSearch.autocomplete.addListener('place_changed', (e) => {
      this.onSearch(e);

    });
  }


  onPlaceChanged(result, clicked) {

    let searchedCountry = "";
    const address_text = result.formatted_address || result.name;
    let geolocation = null;
    let isCity = null;

    //check if location is administrative_area_level_3
    let resType = result.address_components;

    if (typeof resType != 'undefined') {
      for (let item of resType) {
        if (item.types[0] === 'administrative_area_level_3' || item.types[0] === 'administrative_area_level_2' || item.types[0] === 'administrative_area_level_1') {
          isCity = true;
        }
      }
    }

    if (result.place_id) {

      geolocation = {
        lat: result.geometry.location.lat(),
        lng: result.geometry.location.lng(),
        bounds: JSON.parse(JSON.stringify(result.geometry.viewport)),
        _type: (
          [
            // google.maps.GeocoderLocationType.APPROXIMATE,
            google.maps.GeocoderLocationType.RANGE_INTERPOLATED,
            google.maps.GeocoderLocationType.ROOFTOP
          ].indexOf(result.types[0]) > -1
        ) ? this.StoreLocator.AddressType.PointOnMap : this.StoreLocator.AddressType.Generic
      };


      Zero.$state.StoreLocator.Location.Bounds = geolocation.bounds;

      if (clicked) {
        Zero.$state.StoreLocator.Location.Center = {
          lat: geolocation.lat,
          lng: geolocation.lng
        };

        geolocation._type = "_fixed_";
      } else {
        Zero.$state.StoreLocator.Location.Center = null;
      }

      const isCountry = result.types.indexOf("country") > -1;

      if (isCity) {
        geolocation._type = "_fixed_";
      }

      if (isCountry) {
        searchedCountry = result.address_components['0'].short_name;
      }


    } else {
      Log.w("No address found for", address_text);
      Zero.$state.StoreLocator.Location.Address = address_text;
    }

    // manually trigger event for tracking purposes
    $("body").trigger("StoreLocator:Search:Place", {place: geolocation, address: address_text, searchedCountry: searchedCountry});
    this.CAST("StoreLocator:Search:Place", {place: geolocation, address: address_text, searchedCountry: searchedCountry});
  }

}

export {
  ZSearch
};
